<dialog #modal class="modal" appPreventEscClose>

    <div class="modal-box p-0 w-11/12 max-w-5xl overflow-y-hidden">

        <div class="py-5 relative">

            <div class="flex justify-between items-center px-5">
                <h2 class="text-lg font-semibold capitalize">
                    {{type}} : {{categoryData?.group_name || categoryData?.class_name || categoryData?.department_name}}
                </h2>
                <div class="flex items-center gap-2">
                    <button class="btn btn-sm btn-primary" (click)="closeModal('save')" [disabled]="isreqSending">
                        @if (isreqSending) {
                        <i class="ri-loader-2-line animate-spin"></i>
                        }@else {
                        <span><i class="ri-user-add-line"></i> Add Students</span>
                        }

                    </button>
                    <button class="btn btn-sm bg-green-400" (click)="isgroupstudnetclciked($event)">
                         @if (!isviewgroupstudents) {
                        <span>View Group Students</span>
                         }@else {
                        <span >Get All Students</span>
                         }
                    </button>
                    <button class="btn btn-sm btn-circle btn-ghost" (click)="closeModal('close')"><i
                            class="ri-close-line"></i></button>
                </div>
            </div>

            <hr class="my-3">

            <form class="px-5" [formGroup]="filterForm" (ngSubmit)="applyFilters()">
                <div class="flex flex-wrap justify-between items-center mt-5 gap-3">
                    <div class="flex flex-wrap items-center gap-3">

                        <select class="select select-sm select-bordered w-32 text-xs font-semibold"
                            formControlName="department" (change)="setFields($event, 'department')">
                            <option selected [value]="null">Departments</option>
                            @for (i of departments; track $index) {
                            <option class="text-base" [value]="i?.id">{{i?.department_name}}</option>
                            }
                        </select>

                        <select class="select select-sm select-bordered w-32 text-xs font-semibold"
                            formControlName="class" (change)="setFields($event, 'class')">
                            <option selected [value]="null">Class</option>
                            @for (i of classes; track $index) {
                            <option class="text-base" [value]="i?.id">{{i?.class_name}}</option>
                            }
                        </select>
                        <select class="select select-sm select-bordered w-32 text-xs font-semibold"
                            formControlName="batch">
                            <option selected [value]="null">Batch</option>
                            @for (i of batches; track $index) {
                            <option class="text-base" [value]="i?.id">{{i?.batch_name}}</option>
                            }
                        </select>
                        <select class="select select-sm select-bordered w-32 text-xs font-semibold"
                            formControlName="academic_year">
                            <option selected [value]="null">Academic Year</option>
                            @for (i of academicYears; track $index) {
                            <option class="text-base" [value]="i?.id">{{i?.alias || i?.name}}</option>
                            }
                        </select>
                        <select class="select select-sm select-bordered w-32 text-xs font-semibold"
                            formControlName="status">
                            <option selected [value]="null">Status</option>
                            <option class="text-base" value="1">Active</option>
                            <option class="text-base" value="0">Inactive</option>
                        </select>
                    </div>

                    <div class="flex items-center gap-3">
                        <label class="input input-sm input-bordered flex items-center gap-2">
                            <i class="ri-search-line"></i>
                            <input type="text" class="grow" placeholder="Search" formControlName="search" />
                        </label>
                        <button type="submit" class="btn btn-sm btn-primary ">Apply Filter <i
                                class="ri-filter-3-line"></i></button>
                        @if (isFilterApplied) {
                        <button type="button" class="btn btn-sm" (click)="resetSearchForm()">Clear</button>
                        }
                        <button type="button" class="btn btn-sm" (click)="setTableView()">
                            @if (!isSelectedView) {
                            View Selection <span>({{selectedStudents.length}})</span>
                            }@else {
                            Show List
                            }
                        </button>
                    </div>

                </div>
            </form>
            <hr class="my-3">

            <div class="px-5 overflow-auto h-[22rem] relative">

                @defer (when isDataReady) {
                <div class="">
                    <table class="table">
                        <!-- head -->
                        <thead>
                            <tr>
                                <th><input (click)="selectAllStudents($event)"
                                        [checked]="studentList.length === selectedStudents.length"
                                        [disabled]="studentList.length === 0 || isSelectedView" type="checkbox"
                                        class="checkbox checkbox-sm" /></th>
                                <th>Name</th>
                                <th>Contact</th>
                                @if(!isviewgroupstudents){
                                <th>Academic Year</th>
                                <th>Status</th>
                                }
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            @if(!isviewgroupstudents){
                            @for (i of studentList; track $index) {
                                @if (i?.is_active) {
                            <tr>
                                <th><input (change)="selectStudent($event,i)" [checked]="isStudentSelected(i.id)"
                                        type="checkbox" name="student" class="checkbox checkbox-sm" /></th>
                                <td class="whitespace-nowrap">{{i?.first_name}}</td>
                                <td class="flex flex-col">
                                    <span>{{i?.mobile}}</span>
                                    <span>{{i?.email_id}}</span>
                                </td>
                                <td>{{i?.academic_year ?? '-'}}</td>
                                <td>@if (i.is_active ?? false) {
                                    <span class="badge bg-green-500 text-white">Active</span>
                                    }@else{
                                    <span class="badge bg-red-500 text-white">Inactive</span>
                                    }
                                </td>
                                <!-- <td>
                                    <div class="flex gap-2 items-center">
                                        <a [routerLink]="['/student', i?.id]" target="_blank"
                                            class="btn btn-sm flex items-center btn-light"><i
                                                class="ri-eye-line"></i></a>
                                    </div>
                                </td> -->
                            </tr>
                            }
                            }
                        }
                            @if(isviewgroupstudents){
                            @for (i of groupStudentsList; track $index) {
                            <tr>
                                <th><input  [checked]="true"
                                        type="checkbox" name="student" class="checkbox checkbox-sm" /></th>
                                <td class="break-words">{{i?.first_name}}</td>
                                <td class="flex flex-col">
                                    <span>{{i?.mobile}}</span>
                                    <span>{{i?.email_id}}</span>
                                </td>
                            </tr>
                            }
                        }
                    </table>
                </div>
                }
                @placeholder {
                <app-loader></app-loader>
                }
                
                
                
                
            </div>
                        <hr class="my-3">

            <div *ngIf="!isviewgroupstudents" class="mt-5 flex justify-center">
                    <app-pagination [data]="paginationData" (pageChange)="pageChange($event)"></app-pagination>
            </div>
        </div>
    </div>
</dialog>
